// Types shared across multiple core components
var FieldTypes = /*#__PURE__*/function (FieldTypes) {
  FieldTypes["text"] = "text";
  FieldTypes["number"] = "number";
  FieldTypes["range"] = "range";
  FieldTypes["email"] = "email";
  FieldTypes["password"] = "password";
  FieldTypes["date"] = "date";
  FieldTypes["search"] = "search";
  FieldTypes["radio"] = "radio";
  FieldTypes["checkbox"] = "checkbox";
  FieldTypes["switch"] = "switch";
  FieldTypes["textarea"] = "textarea";
  FieldTypes["select"] = "select";
  return FieldTypes;
}({});

export { FieldTypes };